import { Routes } from '@angular/router';
import { HomePageComponent } from './components/home-page/home-page.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { TermsComponent } from './components/terms/terms.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { LoginComponent } from './components/login/login.component';
import { AgentsComponent } from './components/agents/agents.component';
import { CampaignsComponent } from './components/campaigns/campaigns.component';
import { ContactusComponent } from './components/contactus/contactus.component';
import { CreatorComponent } from './components/creator/creator.component';
import { CampaignComponent } from './components/campaign/campaign.component';
import { AgentComponent } from './components/agent/agent.component';
import { ForManagersComponent } from './components/for-managers/for-managers.component';
import { UsersComponent } from './components/users/users.component';
import { AdminComponent } from './components/admin/admin.component';
import { AgentDashboardComponent } from './components/agent-dashboard/agent-dashboard.component';
import { CreatorDashboardComponent } from './components/creator-dashboard/creator-dashboard.component';
import { StaticPagesComponent } from './components/static-pages/static-pages.component';
import { AdminDashboardComponent } from './components/admin-dashboard/admin-dashboard.component';
import { AdminPaymentsComponent } from './components/admin-payments/admin-payments.component';
import { SourceReportComponent } from './components/source-report/source-report.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { DocumentsComponent } from './components/documents/documents.component';
import { AccountComponent } from './components/account/account.component';
import { SettingsComponent } from './components/settings/settings.component';
import { DeliverableComponent } from './components/deliverable/deliverable.component';
import { RosterComponent } from './components/roster/roster.component';
import { InvoicesComponent } from './components/invoices/invoices.component';
import { InvoiceComponent } from './components/invoice/invoice.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { FaqComponent } from './components/faq/faq.component';
import { HelpComponent } from './components/help/help.component';
import { CampaignMainComponent } from './components/campaign-main/campaign-main.component';
import { ResearchComponent } from './components/research/research.component';
import { ChartComponent } from './components/chart/chart.component';
import { RostersComponent } from './components/rosters/rosters.component';
import { TiktokCallbackComponent } from './components/tiktok-callback/tiktok-callback.component';
import { TiktokSuccessComponent } from './components/tiktok-success/tiktok-success.component';
import { AdminGuard, AgentGuard, AuthGuard, ResearchGuard } from './components/authGuard';
import { CreatorTileComponent } from './components/creator-tile/creator-tile.component';
import { BankComponent } from './components/bank/bank.component';
import { OauthComponent } from './components/oauth/oauth.component';
import { MediaKitComponent } from './components/media-kit/media-kit.component';
import { DeleteDataComponent } from './components/delete-data/delete-data.component';
import { OauthSuccessComponent } from './components/oauth-success/oauth-success.component';
import { OauthErrorComponent } from './components/oauth-error/oauth-error.component';
import { PublicCreatorsComponent } from './components/public-creators/public-creators.component';
import { VideoAnalyticsComponent } from './components/video-analytics/video-analytics.component';
import { EmailInBioChangesComponent } from './components/email-in-bio-changes/email-in-bio-changes.component';
import { CrmComponent } from './components/crm/crm.component';
import { CrmGraphComponent } from './components/crm-graph/crm-graph.component';
import { OutreachComponent } from './components/outreach/outreach.component';
import { PublicCampaignAnalyticsComponent } from './components/public-campaign-analytics/public-campaign-analytics.component';

export const routes: Routes = [
    { path: '', component: StaticPagesComponent, children: [
      { path: '', component: HomePageComponent},
      { path: 'formanagers', component: ForManagersComponent },
      { path: 'aboutus', component: AboutUsComponent },
      { path: 'terms', component: TermsComponent },
      { path: 'privacy', component: PrivacyComponent },
      { path: 'contactus', component: ContactusComponent },
      { path: 'delete-data', component: DeleteDataComponent },
      { path: 'oauthSuccess', component: OauthSuccessComponent },
      { path: 'oauthError', component: OauthErrorComponent },
    ]},
    // { path: 'forcreators', component: ForCreatorsComponent },
    // { path: 'formanagers', component: ForManagersComponent },
    // { path: 'aboutus', component: AboutUsComponent },
    // { path: 'contracts', component: ContractsComponent },
    // { path: 'terms', component: TermsComponent },
    // { path: 'privacy', component: PrivacyComponent },
    // { path: 'contactus', component: ContactusComponent },

    { path: 'chart', component: ChartComponent},
    { path: 'tiktokcallback', component: TiktokCallbackComponent},
    { path: 'tiktokSuccess', component: TiktokSuccessComponent},

    { path: 'admin', canActivate: [AdminGuard], component: AdminComponent, children: [
      { path: '', component: AdminDashboardComponent, data: { pageTitle: 'Dashboard' } },
      { path: 'dashboard', component: AdminDashboardComponent, data: { pageTitle: 'Dashboard' } },
      { path: 'users', component: UsersComponent, data: { pageTitle: 'Users' } },
      { path: 'agents', component: AgentsComponent, data: { pageTitle: 'Agents' } },
      { path: 'agents/:id', component: AgentComponent, data: { pageTitle: 'Agent', backRoute: '/admin/agents' } },
      { path: 'creators/:id', component: CreatorComponent, data: { pageTitle: 'Creator' } },
      { path: 'payments', component: AdminPaymentsComponent, data: { pageTitle: 'Payments' } },
      { path: 'notifications', component: NotificationsComponent, data: { pageTitle: 'Notifications' } },
      { path: 'documents', component: DocumentsComponent, data: { pageTitle: 'Documents' } },
      { path: 'account', component: AccountComponent, data: { pageTitle: 'Account' } },
      { path: 'settings', component: SettingsComponent, data: { pageTitle: 'Settings' } },
      { path: 'campaigns', component: CampaignsComponent, data: { pageTitle: 'Campaigns' } },
      { path: 'campaigns/:id', component: CampaignComponent, data: { pageTitle: 'Campaign Details', backRoute: '/admin/campaigns' } },
      { path: 'deliverables/:id', component: DeliverableComponent, data: { pageTitle: 'Deliverable' } }
    ]},

    { path: 'research', canActivate: [ResearchGuard], component: ResearchComponent },
    { path: 'source', canActivate: [AgentGuard], component: SourceReportComponent },

    { path: 'agent', canActivate: [AgentGuard], component: AgentComponent, children: [
      { path: 'oauth', component: OauthComponent, data: { pageTitle: 'Connect Accounts' } },
      { path: 'tiktokcallback', component: TiktokCallbackComponent },
      { path: '', component: AgentDashboardComponent, data: { pageTitle: 'Campaigns' } },
      { path: 'dashboard', component: AgentDashboardComponent, data: { pageTitle: 'Campaigns' } },
      { path: 'rosters/:id', component: RosterComponent, data: { pageTitle: 'Roster Details', backRoute: '/agent/rosters' } },
      { path: 'rosters', component: RostersComponent, data: { pageTitle: 'Roster' } },
      { path: 'users', component: UsersComponent, data: { pageTitle: 'Users' } },
      { path: 'invoices', component: InvoicesComponent, data: { pageTitle: 'Invoices' } },
      { path: 'invoices/:id', component: InvoiceComponent, data: { pageTitle: 'Invoice', backRoute: '/agent/invoices' } },
      { path: 'campaigns/:campaignId', component: CampaignComponent, data: { pageTitle: 'Campaign Details', backRoute: '/agent/dashboard' }, children: [
        {path: '', component: CampaignMainComponent}
      ]},
      { path: 'notifications', component: NotificationsComponent, data: { pageTitle: 'Notifications' } },
      { path: 'payments', component: PaymentsComponent, data: { pageTitle: 'Payments' } },
      { path: 'account', component: AccountComponent, data: { pageTitle: 'Account' } },
      { path: 'settings', component: SettingsComponent, data: { pageTitle: 'Settings' } },
      { path: 'faq', component: FaqComponent, data: { pageTitle: 'FAQ' } },
      { path: 'help', component: HelpComponent, data: { pageTitle: 'Help' } },
      { path: 'creator-tile', component: CreatorTileComponent, data: { pageTitle: 'Creator Tile' } },
      { path: 'bank', component: BankComponent, data: { pageTitle: 'Bank' } },
      { path: 'video-analytics', component: VideoAnalyticsComponent, data: { pageTitle: 'Video Analytics' } },
      { path: 'email-in-bio', component: EmailInBioChangesComponent, data: { pageTitle: 'Email In Bio' } },
      { path: 'outreach', component: OutreachComponent, data: { pageTitle: 'Outreach' } },
      { path: 'crm', component: CrmComponent, data: { pageTitle: 'CRM' } },
      { path: 'crm-graph', component: CrmGraphComponent, data: { pageTitle: 'CRM Graph', backRoute: '/agent/crm' } }
    ]},

    { path: 'mediakit/:id', component: MediaKitComponent },
    { path: 'analytics/:campaignId', component: PublicCampaignAnalyticsComponent },
    { path: 'creators', component: PublicCreatorsComponent },
    { path: 'campaigns', canActivate: [AdminGuard], component: CampaignsComponent },
    { path: 'agent-dashboard', canActivate: [AdminGuard], component: AgentDashboardComponent },
    { path: 'creator-dashboard', canActivate: [AdminGuard], component: CreatorDashboardComponent },
    { path: 'login', component: LoginComponent }
];

